import { type Courses } from "@common/components/Courses/types";
import Icon from "@common/controls/Icon/component";
import { IconType, SystemColor } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import { download } from "@common/lib/api";
import React from "react";

type UploadedMediaProps = {
  download: Courses.LessonDownload;
};
const UploadedMedia = (props: UploadedMediaProps) => {
  const i18n = useI18n();

  return (
    <div className="item">
      <span>{<Icon color={SystemColor.Blue} icon={IconType.File} />}</span>
      <span>{props.download.name}</span>
      <span className="download">
        <a
          onClick={(e) => (
            e.preventDefault(),
            download({
              url: props.download.url,
              name: props.download.name
            })
          )}
          href={props.download.url}
        >
          <Icon icon={IconType.Download} /> {i18n.download}
        </a>
      </span>
    </div>
  );
};

type Props = {
  downloads: Courses.LessonDownload[];
};
export default (props: Props) => (
  <div className="downloads">
    {props.downloads.map((x) => (
      <UploadedMedia key={x.url} download={x} />
    ))}
  </div>
);
